@for (color of colors; track $index) {
  <div panel>
    <button (click)="clickActivate($index)"
            [style]="{color: color?.btnForeColor}">
      <div checkers></div>
      <div [class]="color?.btnClass" [style]="{backgroundColor: color?.btnBackColor}" back></div>
      <mat-icon>{{ color?.icon ?? 'palette' }}</mat-icon>
    </button>
  </div>
}
